var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

export default {
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {


        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        }

    },
    //读取cookie
    getCookie: function() {
        let loginPhone="";
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('='); //再次切割
                //判断查找相对应的值
                if (arr2[0] == 'zsjty_phone') {
                    loginPhone = arr2[1]; //保存到保存数据的地方
                }
            }
        }
        return loginPhone;
    },
    //获取当前时间
    getNowTime: function (){
        var now = new Date();
        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日
        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分
        var ss = now.getSeconds();					//秒
        var clock = year + "-";

        if(month < 10) clock += "0";
        clock += month + "-";
        if(day < 10) clock += "0";
        clock += day + " ";
        // if(hh < 10) clock += "0";
        // clock += hh + ":";
        // if (mm < 10) clock += '0'; 
        // clock += mm + ":"; 
        // if (ss < 10) clock += '0'; 
        // clock += ss; 
        return clock; 
    },
    formatDateGu: function(cellval) {
       var dateVal = cellval + "";
       if(cellval != null) {
       var date = new Date(cellval);
       var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
       var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      
       var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
       var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
       var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
             
       var returnDate = date.getFullYear() + "-" + month + "-" + currentDate;
       
       return returnDate;
       }
    },
    formatDateHMS: function(cellval) {
       var dateVal = cellval + "";
       if(cellval != null) {
       var date = new Date(cellval);
       var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
       var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      
       var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
       var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
       var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
             
       var returnDate = hours + ":" + minutes + ":" + seconds;
       
       return returnDate;
       }
    },
    // 获取近30天的开始日期和结束日期
    getNear30DaysStartDateAndEndDate: function() {
      const now = new Date();
      const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      return {
        startDate: this.formatDate.format(thirtyDaysAgo, 'yyyy-MM-dd'),
        endDate: this.formatDate.format(now, 'yyyy-MM-dd')
      };
    },

    //读取cookie
    getParamsByCookie: function() {
        let cookieInfo = {}    
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('='); //再次切割
                //判断查找相对应的值
                if (arr2[0] == 'dnnyptadmin_token') {
                    cookieInfo.token = arr2[1]
                    // this.token = arr2[1]; //保存到保存数据的地方
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    // this.checkCode = arr2[1];
                    cookieInfo.checkCode = arr2[1]
                } else if (arr2[0] == 'dnnyptadmin_id') {
                    cookieInfo.id = arr2[1]
                    // this.id = arr2[1];
                }
            }
        }
        return cookieInfo
    },

};



// WEBPACK FOOTER //
// ./src/utils/index.js